import {Injectable} from '@angular/core';
import {UpdatePatient} from '../../../../core/models/patient.model';
import {format} from 'date-fns';
import config from '../../../../../config';

@Injectable({
  providedIn: 'root',
})
export class PatientEnrollService {
  carePlanStatuses: any[] = config.CARE_PLAN_STATUSES;



  copyOverPatientInfo({
    referenceNumber,
    firstName,
    lastName,
    birthday,
    gender: genderValue,
    phoneNumber,
    email,
    race,
    ethnicity,
    address,
    priority,
    patientType,
    doctorFirstName,
    doctorLastName,
    doctorContact,
    doctorAddress,
    contactEmail,
  }: any): UpdatePatient {
    const tempPatient: UpdatePatient = new UpdatePatient();

    tempPatient.updatePersonalInfo.dateOfBirth = format(birthday, 'MM/dd/yyyy');

    tempPatient.updatePersonalInfo.email = email;
    tempPatient.updatePersonalInfo.contactEmail = contactEmail;
    tempPatient.updatePersonalInfo.firstName = firstName;
    tempPatient.updatePersonalInfo.lastName = lastName;
    tempPatient.updatePersonalInfo.gender = genderValue;
    tempPatient.updatePersonalInfo.primaryPhoneNumber = phoneNumber;
    tempPatient.updatePersonalInfo.referenceNumber = referenceNumber;
    tempPatient.updatePersonalInfo.race = race;
    tempPatient.updatePersonalInfo.ethnicity = ethnicity;
    tempPatient.updatePersonalInfo.priority = priority;
    tempPatient.updatePersonalInfo.patientType = patientType;

    tempPatient.updatePersonalInfo.doctorFirstName = doctorFirstName;
    tempPatient.updatePersonalInfo.doctorLastName = doctorLastName;
    tempPatient.updatePersonalInfo.doctorContact = doctorContact;
    tempPatient.updatePersonalInfo.doctorAddress = doctorAddress;

    if (address) {
      tempPatient.updatePersonalInfo.address = address.address1;
      tempPatient.updatePersonalInfo.address2 = address.address2;
      tempPatient.updatePersonalInfo.city = address.city;
      tempPatient.updatePersonalInfo.zipCode = address.zipcode;
      tempPatient.updatePersonalInfo.state = address.state;
      tempPatient.updatePersonalInfo.country = address.country;
      tempPatient.updatePersonalInfo.gpsLat = address.gpsLatitude;
      tempPatient.updatePersonalInfo.gpsLong = address.gpsLongitude;
    }

    // tempPatient.updatePersonalInfo.primaryCareProvider = primaryCareProvider;
    // tempPatient.updatePersonalInfo.createdBy = createdBy;
    // tempPatient.updatePersonalInfo.dateCreated = dateCreated;
    // tempPatient.updatePersonalInfo.timeCreated = timeCreated;
    // tempPatient.updatePersonalInfo.medicalCenter = medicalCenter;

    return tempPatient;
  }
}
